import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { AuthProvider } from './auth/AuthContext.tsx';
import { startOfflineQueue } from './lib/offlineQueue.ts';
import { watchForStaleBuild } from './lib/staleBuild.ts';
import './index.css';

// Begin draining any writes queued while offline, and re-drain on regained connectivity.
startOfflineQueue();

// A chunk that fails to load means a deploy has moved on without this device. Reload onto it
// rather than letting a lazy route blow up in front of whoever is mid-shift.
watchForStaleBuild();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);
